import React, {useState, useEffect, useCallback} from 'react';
import ReactDOM from 'react-dom';
import TourStep from './TourStep';
import './index.less';

const Tour = (props) => {
    const {
        steps = [],
        prevTourTotal = 0,
        total,
        open,
        title,
        mode = 'dark',
        onFinish = () => {},
        onNext = () => {},
        onPrev = () => {}
    } = props;
    const [currentStepIndex, setCurrentStepIndex] = useState(0);
    const [tourVisible, setTourVisible] = useState(open);

    useEffect(() => {
        if (open) {
            startTour(); // 启动tour
        }
        else {
            finishTour(); // 隐藏tour
        }
    }, [open]);

    const startTour = () => {
        setCurrentStepIndex(0);
        setTourVisible(true);
    };

    const finishTour = () => {
        setTourVisible(false); // 隐藏tour
        setCurrentStepIndex(0); // 重置步骤索引
    };

    const nextStep = useCallback(() => {
        if (currentStepIndex < steps.length - 1) {
            setCurrentStepIndex(currentStepIndex + 1);
            onNext(prevTourTotal + currentStepIndex + 1);
        }
        else {
            onNext(prevTourTotal + currentStepIndex + 1);
            finishTour();
            if (onFinish) {
                onFinish();
            };
        }
    }, [currentStepIndex, steps.length]);

    const prevStep = useCallback(() => {
        if (currentStepIndex > 0) {
            setCurrentStepIndex(currentStepIndex - 1);
            onPrev(prevTourTotal + currentStepIndex + 1);
        }
    }, [currentStepIndex, steps.length]);

    const handleClose = () => {
        finishTour();
        if (onFinish) {
            onFinish();
        };
    };

    const tourContainer = (
        <div className="huibo-ture">
            {(tourVisible && steps.length) ? (
                <TourStep
                    title={title}
                    step={steps[currentStepIndex]}
                    currentStepIndex={currentStepIndex}
                    stepLength={steps.length}
                    prevTourTotal={prevTourTotal || 0}
                    total={total || steps.length}
                    visible={tourVisible}
                    onPrev={prevStep}
                    onNext={nextStep}
                    mode={mode}
                    onClose={handleClose}
                />
            ) : null}
        </div>
    );

    return tourVisible ? ReactDOM.createPortal(tourContainer, document.body) : null;
};

export default Tour;